
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import Pullquote from './pullquote'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "pullquote"
    }}>{`Pullquote`}</h1>
    <hr />
    <h2 {...{
      "id": "pullquote-1"
    }}>{`Pullquote`}</h2>
    <Playground __position={1} __code={'<Pullquote text=\"Many liberals have become conservative\" />'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      Pullquote
    }} mdxType="Playground">
  <Pullquote text="Many liberals have become conservative" mdxType="Pullquote" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={Pullquote} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;